module.exports = __webpack_public_path__ + "img/pr-53.7857e4e4.png";